import React, { useContext, useEffect, useState } from 'react';
import { db } from "../../firebase";
import styles from "./index.module.css";
import { doc, getDoc } from 'firebase/firestore';
import { ThemeContext } from "../../context/ThemeContext";

export default function ProjectDetails(props) {
    const [userFeatures, setUserFeatures] = useState([]);
    const [loading, setLoading] = useState(true);
    const { isDarkMode } = useContext(ThemeContext);
    const [theme, setTheme] = useState(isDarkMode);
  
    useEffect(() => {
      setTheme(isDarkMode);
    }, [isDarkMode])

    useEffect(() => {
        async function getUserFeatures() {
            try {
                const productId = String(props.productId);
                const docRef = doc(db, "products", productId);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    const data = docSnap.data();
                    if (data.userFeatures && Array.isArray(data.userFeatures)) {
                        setUserFeatures(data.userFeatures);
                    }
                } else {
                    setUserFeatures([]);
                }
            } catch (error) {
                console.error("Error fetching user features:", error);
            } finally {
                setLoading(false);
            }
        }

        if (props.productId) {
            getUserFeatures();
        }
    }, [props.productId]);

    // Function to group and sort the features
    const sortedFeatures = () => {
        // Group by category
        const grouped = userFeatures.reduce((acc, feature) => {
            if (!acc[feature.categoryName]) {
                acc[feature.categoryName] = [];
            }
            acc[feature.categoryName].push(feature);
            return acc;
        }, {});

        // Sort categories and features
        const sortedCategories = Object.keys(grouped).sort(); // Sort category names alphabetically
        const sortedGrouped = sortedCategories.map((category) => {
            const sortedFeatures = grouped[category].sort((a, b) => a.featuresName.localeCompare(b.featuresName)); // Sort features within each category
            return { categoryName: category, features: sortedFeatures };
        });

        return sortedGrouped;
    };
    const backgroundColorDarkMode = "#141414";
    const backgroundColorLightMode = "white";
    const textColorDarkMode = "white";
    const textColorLightMode = "black";
  
    return (
        <div className={styles.backdrop} onClick={() => props.setIsUserFeaturesVisible(false)}>
            <div className={styles.popup} onClick={(e) => e.stopPropagation()} style={{ backgroundColor: theme ? backgroundColorDarkMode : backgroundColorLightMode }}>
                <h3>User Features</h3>

                {loading ? (
                    <div>Loading...</div>
                ) : userFeatures.length > 0 ? (
                    <div style={{ maxHeight: '300px', overflowY: 'auto', width: '100%' }}>
                        <table style={{ width: '80%', margin: '0 auto' }}>
                            <thead>
                                <tr>
                                    <th>Category</th>
                                    <th>Feature</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sortedFeatures().map((group, index) => (
                                    group.features.map((feature, subIndex) => (
                                        <tr key={subIndex} >
                                            <td style={{ color: theme ? textColorDarkMode : textColorLightMode}}>{group.categoryName}</td>
                                            <td style={{ color: theme ? textColorDarkMode : textColorLightMode}}>{feature.featuresName}</td>
                                        </tr>
                                    ))
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div style={{ color: theme ? textColorDarkMode : textColorLightMode}}>No user features available</div>
                )}
            </div>
        </div>
    );
}